import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { AppService } from "../../app.service";
import { Observable } from "rxjs/Observable";


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private appService: AppService) { }

    canActivate() {
        const token = localStorage.getItem("ani-token");
        if (token == undefined || token === "undefined") {
            this.router.navigate(["/login"]);
            return false;
        }

        return this.appService.checkAuthentication(token).map(x => {
            if (x.authenticated) {
                this.appService.username = x.username;
                return true;
            } else {
                this.appService.username = undefined;
                this.router.navigate(["/login"]);
                return false;
            }
        }).catch(() => {
            this.router.navigate(["/login"]);
            return Observable.of(false);
        });
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/guards/auth.guard.ts